import { render, staticRenderFns } from "./StepOnlyFeedback.vue?vue&type=template&id=106485c5&scoped=true&"
import script from "./StepOnlyFeedback.vue?vue&type=script&lang=js&"
export * from "./StepOnlyFeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106485c5",
  null
  
)

export default component.exports